import styled from "styled-components";


export const Container = styled.main`
  position: relative;
  z-index: 0;
  padding: 0 8rem;
  overflow-x: hidden;
  #tsparticles{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  @media (max-width: 740px){
    padding: 0 2rem;
    margin:0 2rem;
  }

  @media(max-width: 360px){
    padding: 0 1rem;
    overflow:show;
    margin:0 2rem;
  }
`